<template>
  <v-form ref="form">
    <v-autocomplete
      id="temas-select"
      v-model="value.municipioId"
      :items="values"
      :label="title"
      placeholder="Selecione..."
      v-on:change="
        (e) => {
          $emit('onChange', value);
          $emit(
            'nameChange',
            allValues
              .filter((val) => value.municipioId.includes(val.municipioId))
              .map((item) => item.nome)
          );
        }
      "
      outlined
      :disabled="disabled"
      :clearable="clearable"
      :multiple="multiple"
      item-value="municipio.municipioId"
      item-text="municipio.nome"
      :rules="rules"
    >
      <template v-slot:selection="{ item, index }">
        <v-chip v-bind="item" small v-if="index < maxDisplay">
          <span>{{ item.municipio.nome }}</span>
        </v-chip>
        <span v-if="index === maxDisplay" class="grey--text caption"
          >(+{{ value.municipioId.length - maxDisplay }}
          {{
            isParceiro
              ? "Parceiros"
              : isSala
              ? "Salas"
              : isGov
              ? "Projetos"
              : "Municípios"
          }})</span
        >
      </template>
      <template slot="no-data">
        Nenhum
        {{
          isParceiro
            ? "Parceiro"
            : isSala
            ? "Sala"
            : isGov
            ? "Projeto"
            : "Município"
        }}
        retornado
      </template>
    </v-autocomplete>
  </v-form>
</template>

<script>
import { territoriosMunicipioAPI } from "@/modules/gestao-territorios/API/territorioMunicipioAPI";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ComboboxMunicipioTerritorio",
  computed: {
    ...mapGetters(["isSala", "isParceiro", "isGov"]),
  },
  props: {
    rules: {
      type: Array,
      default: () => {
        [];
      },
    },
    clearable: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    value: { type: Array | Object },
    territorioId: { type: String },
    title: {
      type: String,
      default: () => {
        return `Municípios`;
      },
    },
  },
  watch: {
    territorioId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.loadCities();
        }
      },
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    loadCities() {
      this.setLoading(true);
      territoriosMunicipioAPI
        .listByTerritorio(this.territorioId)
        .then((resp) => {
          this.values = resp.data;
          this.allValues = resp.data;
          this.setLoading(false);
        })
        .catch((e) => {
          console.log("error on comboboxMunicipioTerritorio: ", e);
          this.$notification.error("Error ao buscar municípios");
          this.setLoading(false);
        });
    },
  },

  data() {
    return {
      values: [],
      allValues: [],
      maxDisplay: 1,
    };
  },
};
</script>
